/* @flow weak */
import { List } from 'immutable'
import { Record } from '../transit'
import * as appActions from '../app/actions'
import * as authActions from '../auth/actions'
import * as usersActions from '../users/actions'
import * as lessonsActions from '../lessons/actions'
// import * as lessonsActions from '../lessons/actions'

const LOADER_TYPES = {
  OVERLAY: 'OVERLAY',
  POPUP: 'POPUP',
  MESSAGE: 'MESSAGE',
  ICON: 'ICON',
  BACKGROUND: 'BACKGROUND',
}

const State = Record({
  loaderType: '',
  loader: false,
  message: '',
  errors: new List(),
  success: '',
}, 'loader')

const appReducer = (state = new State(), action) => {
  switch (action.type) {
    case appActions.APP_SET_LOCATION: {
      return new State()
    }

    case lessonsActions.LESSON_LOAD_START:
    case usersActions.USER_LOAD_START:
    case usersActions.SIGN_UP_START:
    case authActions.SIGN_IN_START: {
      return state.set('loader', true)
    }

    case lessonsActions.LESSON_LOAD_SUCCESS:
    case lessonsActions.LESSON_LOAD_ERROR:
    case usersActions.USER_LOAD_SUCCESS:
    case usersActions.USER_LOAD_ERROR:
    case authActions.SIGN_IN_SUCCESS:
    case authActions.SIGN_IN_ERROR:
    case usersActions.SIGN_UP_SUCCESS:
    case usersActions.SIGN_UP_ERROR: {
      return state.set('loader', false)
    }

    case authActions.FORGOT_PASSWORD_START:
      return state
        .set('loaderType', LOADER_TYPES.BACKGROUND)

    case authActions.FORGOT_PASSWORD_SUCCESS:
      return state
        .set('loaderType', '')
        .set('message', 'Na zadaný email byl zaslán email s instrukcemi pro změnu hesla')

    case authActions.RESET_PASSWORD_START:
      return state
        .set('loaderType', LOADER_TYPES.BACKGROUND)

    case authActions.RESET_PASSWORD_SUCCESS:
      return state
        .set('loaderType', '')
        .set('message', 'Heslo bylo úspěšně změněno')

    default:
      return state
  }
}

export default appReducer



// WEBPACK FOOTER //
// ./src/common/loader/reducer.js